var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container bg-white pt-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('sectoral-pe-ratio')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }